import React from 'react';

const Info = ({ info }) => (
  <div className="row">
    <div align="center">
      <div style={{width: '50%'}}>
        <label className="">
          {info}
        </label>
      </div>
      <br />
    </div>
  </div>
);

export default Info;


// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/UI/Info.js